<template>
    <Card
        icon="fas fa-map-marker-alt"
        bg-color="tw:bg-[var(--sitecolor)]"
        title-color="white"
        :title="'Localización'"
        padding="0"
    >
        <div class="tw:p-6 tw:space-y-4">
            <div class="tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:gap-4">
                <div>
                    <ProvinciasSelect
                        :model-value="localData.provincia"
                        @update:modelValue="val => localData.provincia_id = val?.id"
                    />
                </div>
                <div>
                    <LocationsSelect
                        :model-value="localData.location_id"
                        :provincia="localData.provincia_id"
                        :force-multiselect="true"
                        @update:modelValue="val => localData.location_id = val?.id ?? val"
                    />
                </div>
                <div>
                    <BaseInputText
                        id="direccion"
                        name="direccion"
                        :label="'Dirección'"
                        :value="localData.address"
                        rules="required"
                        @input="val => localData.address = val"
                    />
                </div>
            </div>

            <div class="tw:border-t tw:border-gray-100"></div>

            <div class="tw:grid tw:grid-cols-1 tw:gap-4">
                <div>
                    <ToggleSwitch
                        :value="localData.recinto"
                        @input="val => { localData.recinto = val; setRecinto(); }"
                        variant="primary"
                        id="tiene_recinto"
                    >
                        {{ 'Tiene plano/recinto' }}
                    </ToggleSwitch>
                </div>

                <div v-if="localData.recinto" ref="recintoSection">
                    <div class="tw:p-2 tw:mb-1">
                        <p class="tw:text-xs tw:text-blue-700 tw:m-0">
                            {{ 'Debe seleccionar el recinto, para poder publicarlo con recinto ya sea numerado o sin numerar' }}
                        </p>
                    </div>
                    <BaseMultiselect
                        :label="'Recinto'"
                        name="recinto"
                        :value="localData.place_id"
                        :options="recintos"
                        label-key="name"
                        value-key="id"
                        :multiple="false"
                        :rules="localData.recinto ? 'required' : ''"
                        @input="onRecintoSelected"
                    />
                </div>
            </div>
        </div>
    </Card>
</template>

<script setup>
    import { inject, ref } from 'vue';
    import { useScrollOnToggle } from '@/composables/common/useScrollOnToggle';
    import Card from '@/modules/admin/ui/Card.vue';
    import BaseInputText from '@/modules/admin/ui/BaseInputText.vue';
    import BaseMultiselect from '@/modules/admin/ui/BaseMultiselect.vue';
    import ToggleSwitch from '@/modules/admin/ui/ToggleSwitch.vue';
    import ProvinciasSelect from '@/modules/admin/ui/ProvinciasSelect.vue';
    import LocationsSelect from '@/modules/admin/ui/LocationsSelect.vue';

    const localData = inject('eventoFormData');

    const props = defineProps({
        recintos: { type: Array, default: () => [] }
    });

    const emit = defineEmits(['set-recinto', 'change-address']);

    function changeAddress() {
        const recinto = props.recintos.find(r => r.id === localData.place_id);
        if (recinto?.address) {
            localData.address = recinto.address;
        }
    }

    // Sincroniza AMBAS keys en sitio: place_id (lo que escoge el usuario)
    // + place_obj (lo que el backend hidrata y usa Crear.vue/Editar.vue para
    // sobreescribir place_id en submit). Sin esta sincronización aquí, submit
    // sobreescribiría la selección del usuario con el place_obj viejo,
    // "perdiendo" el cambio.
    function onRecintoSelected(val) {
        const found = props.recintos?.find(r => r.id === val) || null;
        localData.place_id = val;
        localData.place_obj = found;
        changeAddress();
    }

    function setRecinto() {
        emit('set-recinto');
    }

    const recintoSection = ref(null);
    useScrollOnToggle(() => localData.recinto, recintoSection);
</script>
